<template>
  <div class="registration-form--inner">

    <h3 class="registration-form-layout__block-title">{{locales && locales.users && locales.users.person}} {{ i + 1 }}</h3>

    <div class="grid grid-cols-1 gap-x-4 gap-y-4 sm:grid-cols-2 md:gap-y-6">
      <theme-radios
        :label="subscriptionsSexInputTitle"
        :name="`person[`+[i]+`][title_id]`"
        :options="subscriptionsSexOptions"
        v-validate="`required|make_choice`"
        :isRequired="true"
      ></theme-radios>

      <theme-radios
          :label="locales && locales.users && locales.users.language"
          :value="defaultLanguage"
          :name="`person[`+[i]+`][language]`"
          :options="languages"
      ></theme-radios>
      <theme-input
        :label="usersFirstName"
        :name="`person[`+[i]+`][first_name]`"
        :placeholder="usersFirstNamePlaceholder"
        v-validate="`required`"
        :isRequired="true"
      ></theme-input>

      <theme-input
        :label="usersMiddleName"
        :name="`person[`+[i]+`][middle_name]`"
        :placeholder="usersMiddleNamePlaceholder"
        :isRequired="true"
      ></theme-input>

      <theme-input
        :label="usersLastName"
        :name="`person[`+[i]+`][last_name]`"
        :placeholder="usersLastNamePlaceholder"
        v-validate="`required`"
        :isRequired="true"
      ></theme-input>

      <theme-calendar
        :label="usersDateOfBirth"
        :name="`person[`+[i]+`][birthdate]`"
        v-validate="`required`"
        :placeholder="usersDateOfBirthPlaceholder"
        :isRequired="true"
        :decades="true"
        :max-date="maxBirthDate"
        :date-mask="true"
      ></theme-calendar>
    </div>

    <div>
      <theme-input
        :label="usersPhoneNumber"
        class="js-unique-phone"
        :name="`person[`+[i]+`][phone_number]`"
        :placeholder="usersPhoneNumberPlaceholder"
        v-validate="`required|phone_number`"
        :isRequired="true"
        @blur="checkPhone"
      ></theme-input>

      <div class="mt-2" v-if="!!is_phone_number_unique">
          <span class="text-[#FF695B] text-[12px]">{{ phoneNumberAlreadyExists }}</span>
          <input type="hidden" name="phone_number_unique" v-validate="`required`" />
      </div>
    </div>


    <div>
      <theme-input
        :label="usersEmail"
        :name="`person[`+[i]+`][email]`"
        @blur="checkMail"
        class="js-unique-mail"
        :placeholder="usersEmailPlaceholder"
        v-validate="`required|email`"
        :isRequired="true"
      ></theme-input>

      <div class="mt-2" v-if="is_user_already_exists == 1">
        <span class="text-[#FF695B] text-[12px]">{{ isUserAlreadyExists }}</span>
        <input type="hidden" name="user_already_exists" v-validate="`required`" />
      </div>

      <div class="mt-2" v-else-if="is_user_already_exists == 2">
        <span class="text-[#FF695B] text-[12px]">{{ isUserBanned }}</span>
        <input type="hidden" name="user_already_exists" v-validate="`required`" />
      </div>
    </div>
  </div>
</template>
<script>
import ThemeInput from "./ThemeInput.vue";
import ThemeCalendar from "./ThemeCalendar.vue";
import { mapGetters, mapActions } from "vuex";
import sweetalert from "sweetalert";
import $ from "jquery";

export default {
  $_veeValidate: {
    validator: "new",
  },
  components: {
    ThemeInput,
    ThemeCalendar,
  },
  inject: ["$validator"],
  data() {
    return {
      is_user_already_exists: 0,
      is_phone_number_unique: 0,
    }
  },
  props: {
    i: {
      default: 0,
      type: Number
    },
    usersFirstName: {
      default: "",
      type: String
    },
    usersFirstNamePlaceholder: {
      default: "",
      type: String
    },
    usersMiddleName: {
      default: "",
      type: String
    },
    usersMiddleNamePlaceholder: {
      default: "",
      type: String
    },
    usersLastName: {
      default: "",
      type: String
    },
    usersLastNamePlaceholder: {
      default: "",
      type: String
    },
    usersDateOfBirth: {
      default: "",
      type: String
    },
    usersDateOfBirthPlaceholder: {
      default: "",
      type: String
    },
    usersPhoneNumber: {
      default: "",
      type: String
    },
    usersPhoneNumberPlaceholder: {
      default: "",
      type: String
    },
    usersEmail: {
      default: "",
      type: String
    },
    usersEmailPlaceholder: {
      default: "",
      type: String
    },
    isUserAlreadyExists: {
      default: '',
      type: String
    },
    isUserBanned: {
      default: '',
      type: String
    },
    phoneNumberAlreadyExists: {
      default: '',
      type: String
    },
    subscriptionsSexInput: {
      default: "",
      type: String,
    },
    subscriptionsSexInputTitle: {
      default: "",
      type: String,
    },
    subscriptionsSexOptions: {
      default: () => {},
      type: Object,
    },
    defaultLanguage: {
      default: "",
      type: String,
    },
    languages: {
      default: () => {},
      type: Object,
    },
  },
  methods: {
    checkMail: function(event) {
      var email = event.target.value;
      if (email == "") return (this.is_user_already_exists = 0);
      var vm = this;
      vm.$emit('uniqueness-check-pending', true);
      $.ajax({
        url: `/api/users/check-mail`,
        method: "post",
        data: {
          email: email
        },
        success: function(result) {
          var elements = document.getElementsByClassName('js-unique-mail'),
              mails = [];

            Array.prototype.forEach.call(elements, function(el) {
                // Do stuff here
                let val = el.querySelector('input').value;
                if(el.querySelector('input') != event.target && val != ''){
                  mails.push(val);
                }
            });

          if (parseInt(result) === 2) {
            vm.is_user_already_exists = 2;
          } else if (parseInt(result) === 1) {
            vm.is_user_already_exists = 1;
          } else {
            if (mails.length && mails.indexOf(email) != -1) {
              vm.is_user_already_exists = 1;
            } else {
              vm.is_user_already_exists = 0;
            }
          }
        },
        error: function() {},
        complete: function() {
          vm.$emit('uniqueness-check-pending', false);
        }
      });
    },
    checkPhone: function(event) {
      var phone = event.target.value;
      if (phone == "") return (this.is_phone_number_unique = 0);
      var vm = this;
      var elements = document.getElementsByClassName('js-unique-phone');
      var phones = [];
      Array.prototype.forEach.call(elements, function(el) {
          // Do stuff here
          let val = el.querySelector('input').value;
          if(el.querySelector('input') != event.target && val != ''){
            phones.push(val);
          }
      });
      if(phones.length && phones.indexOf(phone) != -1){
        vm.is_phone_number_unique = 1;
        return;
      }
      vm.$emit('uniqueness-check-pending', true);
      $.ajax({
        url: `/api/subscriptions/check-phone`,
        method: "post",
        data: {
          phone_number: phone
        },
        success: function(result) {
          vm.is_phone_number_unique = parseInt(result) === 1 ? 1 : 0;
        },
        error: function() {},
        complete: function() {
          vm.$emit('uniqueness-check-pending', false);
        }
      });
    },
  },
  computed: {
    ...mapGetters(["locales"]),
    maxBirthDate() {
      return moment().subtract(18, 'years').format('YYYY-MM-DD');
    },
  }
}

</script>